// extracted by mini-css-extract-plugin
export default {"user":"user--SWwh8","info":"info--SNcs1","name":"name--xmLm6","logout-btn":"logout-btn--Py6QC","logoutBtn":"logout-btn--Py6QC"};